// Components
import ProjectBox from "../Elements/ProjectBox";
// Assets
import ProjectImg1 from "../../assets/img/projects/bagger1.jpg";
import ProjectImg2 from "../../assets/img/projects/bagger2.jpg";
import ProjectImg3 from "../../assets/img/projects/bagger3.jpg";
import ProjectImg4 from "../../assets/img/projects/bagger4.jpg";
import ProjectImg5 from "../../assets/img/projects/bagger5.jpg";
import ProjectImg6 from "../../assets/img/projects/bagger6.jpg";


export default function Projects() {
  const images = [
    {
      url: ProjectImg1,
      title: "Liebherr 900 Radlader",
      text: "15.8t",
    },
    {
      url: ProjectImg2,
      title: "Kubota KX71-3 Minibagger",
      text: "2.8t",
    },
    {
      url: ProjectImg4,
      title: "Liebherr 904 Litronic Radlader",
      text: "17.8t",
    },
    {
      url: ProjectImg3,
      title: "Kubota KX71-3 Minibagger",
      text: "2.8t",
    },
    {
      url: ProjectImg6,
      title: "Atego 818 Mercedes-Benz",
      text: "7.5t",
    },
    {
      url: ProjectImg5,
      title: "Liebherr 554 Radlader",
      text: "17.3t",
    }
  ];

  return (
    <section id="fuhrpark" className="text-center py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <h1 className="text-3xl md:text-4xl font-extrabold">Unser Fuhrpark</h1>
          <h4 className="text-sm md:text-base font-semibold mt-4">Unser technisch einwandfreier, moderne Fuhrpark und unsere flexiblen, erfahrenen Mitarbeiter garantieren auch Ihnen eine bestmögliche Gesamtleistung bei Ihrem Projekt.</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div key={index}>
              <ProjectBox
                img={image.url}
                title={image.title}
                text={image.text}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
